/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { UserBlocker } from '@/api/types/user';

export interface StoreUserConfigState {
  blockers: UserBlocker[];
}

export default {
  namespaced: true,
  state: {
    blockers: [],
  },
  getters: {},
  actions: {
    [USER.GET_BLOCKERS]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getBlockers().then((res) => {
          commit(USER.GET_BLOCKERS, res);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_BLOCKERS](state, data) {
      state.blockers = data;
    },
  },
};
